import * as React from 'react';

import type {ButtonVariant} from '../button/types';
import {colors} from '../colors/colors';

import styles from './button-icon.module.css';

export const sizes = {
    mini: 'mini',
    tiny: 'tiny',
    small: 'small',
    normal: 'normal',
    big: 'big',
    xlarge: 'xlarge',
    huge: 'huge',
} as const;

type Props = {
    variant?: ButtonVariant;
    size?: keyof typeof sizes;
    icon: React.ComponentType<any>;
    // Overrides the variant mapping fill color,
    // Useful for cases where this isn't used as a shells/button component
    // E.g. SegmentedControlButton
    fillColor?: string;
};

export function ButtonIcon(props: Props) {
    const Icon = props.icon;
    const {size = 'normal', variant = 'secondary'} = props;

    return (
        <div className={styles['button-icon']}>
            <Icon
                wrapWithDiv={false}
                size={getIconSize(size)}
                fill={getFillColor(variant, props.fillColor)}
            />
        </div>
    );
}

function getFillColor(variant: ButtonVariant, fillColor?: string) {
    if (fillColor) {
        return fillColor;
    }

    switch (variant) {
        case 'primary':
        case 'orange':
        case 'save':
        case 'danger':
        case 'ai-blue':
            return '#fff';
        case 'secondary':
            return colors.grey;
        case 'text-primary':
        case 'upgrade':
        case 'contact-blue':
            return colors.blue;
        default:
            return colors.grey;
    }
}

function getIconSize(size: keyof typeof sizes): number {
    switch (size) {
        case 'mini':
            return 11;
        case 'tiny':
            return 12;
        case 'small':
        case 'normal':
            return 13;
        case 'big':
            return 15;
        case 'xlarge':
            return 17;
        case 'huge':
            return 21;
        default:
            return 13;
    }
}
